export const getDefaultParameters = () => {
    const idx = sessionStorage.getItem("private_number") ?? "";
    const co_id = new URLSearchParams(window.location.search).get("co_id") ?? "";
    return { idx, co_id };
};
